import { useEffect, type ReactNode } from "react";
import { Mail, PackageOpen } from "lucide-react";
import { Button } from "@/components/Button";
import { AuthLayout } from "@/templates/AuthLayout";

export default function Join() {
  useEffect(() => {
    document.title = "Get started · stabiliti";
  }, []);

  return (
    <AuthLayout
      title="Get started"
      subtitle="Request access to the supplier portal."
      footer={
        <>
          Already have an account?{" "}
          <a href="/login" className="font-medium text-accent-text hover:underline">
            Sign in
          </a>
        </>
      }
    >
      <div className="text-center">
        <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-accent-subtle text-accent-text [&_svg]:size-6">
          <PackageOpen />
        </div>
        <p className="text-sm leading-relaxed text-fg-muted">
          Accounts are set up by our team. Get in touch and we'll get you onboarded to
          your nature projects and payouts.
        </p>

        <div className="mt-5">
          <Button asChild intent="primary" size="lg" className="h-11 w-full">
            <a href="mailto:hello@stabiliti.io">
              <Mail /> Email hello@stabiliti.io
            </a>
          </Button>
        </div>
      </div>
    </AuthLayout>
  );
}

// Render bare (AuthLayout provides the dark brand shell), like the login page.
Join.layout = (page: ReactNode) => page;
